import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { BulkEditCalendarEventMutation, ViewDatesQuery } from 'graphql.generated';
import { ActionSource } from 'src/app/state/action-sources';

export const OverviewTimelineActions = createActionGroup({
    source: ActionSource.OVERVIEW_TIMELINE,
    events: {
        'Open Actions Menu Button Clicked': props<{ eventId: string }>(),
        'Confirm Event Menu Item Selected': emptyProps(),
        'Complete Event Menu Item Selected': emptyProps(),
        'Book Event Menu Item Selected': emptyProps(),
        'Reschedule Event Menu Item Selected': emptyProps(),
        'Edit Event Menu Item Selected': emptyProps(),
        'More Info Menu Item Selected': emptyProps(),
        'Cancel Event Menu Item Selected': emptyProps(),
        'Confirm Cancel Event Button Clicked': emptyProps(),
        'Undo Cancel Menu Item Selected': emptyProps(),
        'Confirm Undo Cancel Button Clicked': emptyProps(),
        'Delete Menu Item Selected': emptyProps(),
        'Confirm Delete Event Button Clicked': emptyProps(),
        'Event Details Clicked': props<{ eventId: string }>(),
        'Book Event Button Clicked': props<{ eventId: string }>(),
        'Promote Event Button Clicked': props<{ eventId: string }>(),
        'Go To Event Button Clicked': props<{ eventId: string }>(),
        'Uncancel Event Button Clicked': props<{ eventId: string }>(),

        // Success/Error actions
        'Update Event Status Success': props<{
            updatedEvent: BulkEditCalendarEventMutation['bulkEditCalendarEvent']['events'][number];
            jobId: string;
            customSuccessMessage?: string;
        }>(),
        'Update Event Status Error': props<{ error: Error }>(),
        'Delete Event Success': props<{ 
            jobId: string;
            eventId: string;
        }>(),
        'Delete Event Error': props<{ error: Error }>(),
        'Timeline Dates Selected': props<{ timeline: string[] }>(),

        'Availability Scheduled Initialized': emptyProps(),
        'Month Changed': props<{ month: number; year: number }>(),
        'Fetch View Dates Started': props<{ startDate: string; endDate: string }>(),
        'Fetch View Dates Success': props<{ viewDates: ViewDatesQuery['viewDates'] }>(),
        'Fetch View Dates Error': props<{ error: Error }>(),
    },
});
